import SecureLS from "secure-ls";

let ls = new SecureLS({ encodingType: "aes" });

// save anything to secure ls
export const omniSaver = (title: string, data: any) => ls.set(`${title}`, data);
// get anything from secure ls
export const omniGetter = (title: string) => ls.get(`${title}`);
// remove anything from secure ls
export const omniRemover = (title: string) => ls.remove(`${title}`);